import React, { useState, useEffect } from "react";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function HeroBanner() {
    const [dataSource, setDataSource] = useState([]);
    const [index, setIndex] = useState(0);
    const bannerSlides = dataSource?.filter(
        (slide) => slide.image_type === "Banner"
    ) || [];
    useEffect(() => {
        if (bannerSlides.length === 0) return;
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % bannerSlides.length);
        }, 4000);
        return () => clearInterval(interval);
    }, [bannerSlides.length]);
    const nextSlide = () => {
        setIndex((index + 1) % bannerSlides.length);
    };
    const prevSlide = () => {
        setIndex(index === 0 ? bannerSlides.length - 1 : index - 1);
    };
    useEffect(() => {
        fetchBannersData();
    }, []);
    const fetchBannersData = async () => {
        try {
            let url = webEndPoint + "banners";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
            }
        } catch (err) {
            console.error(err);
        }
    };
    return (
        <div className="hero-container">
            {bannerSlides.map((slide, i) => (
                <div key={i} className={`hero-slide ${i === index ? "active" : ""}`}>
                    <img src={slide.image_url} alt="" />
                    {/* <div className="hero-overlay" />
                    <div className="hero-content">
                        <h1>New Collection</h1>
                        <p>Trendy Family Wear Available Now</p>
                        <button className="shop-btn">Shop Now</button>
                    </div> */}
                </div>
            ))}
            <button className="prev" onClick={prevSlide}>&#10094;</button>
            <button className="next" onClick={nextSlide}>&#10095;</button>
            <div className="dots">
                {bannerSlides.map((_, i) => (
                    <span key={i} className={i === index ? "dot active" : "dot"} onClick={() => setIndex(i)} />
                ))}
            </div>
        </div>
    );
}